import { Video, Mic } from "lucide-react";

interface StartButtonsProps {
  onStartVideo: () => void;
  onStartVoice: () => void;
  isLoading: boolean;
}

export default function StartButtons({
  onStartVideo,
  onStartVoice,
  isLoading,
}: StartButtonsProps) {
  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button
            onClick={onStartVideo}
            disabled={isLoading}
            className="btn btn-primary btn-lg"
          >
            {isLoading ? (
              <>
                <span className="loading loading-spinner"></span>
                Starting Session...
              </>
            ) : (
              <>
                <Video className="w-5 h-5" />
                Start Video Chat
              </>
            )}
          </button>
          <button
            onClick={onStartVoice}
            disabled={isLoading}
            className="btn btn-secondary btn-lg"
          >
            {isLoading ? (
              <>
                <span className="loading loading-spinner"></span>
                Starting Session...
              </>
            ) : (
              <>
                <Mic className="w-5 h-5" />
                Start Voice Chat
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
